export enum ThemeColor {
  /** 主题色 */
  Primary = '#FB7C34',
  /** 主题色悬浮（hover）*/
  PrimaryHover = '#FDB085',
  /** 主题色激活（active）*/
  PrimaryActive = '#FC965D',
  /** 主题色禁用 */
  PrimaryDisabled = '#FEE0CE',
  /** 一级文本 */
  TextPrimary = '#2e373e',
  /** 二级文本 */
  TextSecondary = '#819097',
  /** 三级文本 */
  TextTertiary = '#abb4b8',
  /** 占位、提示文字（placeholder）*/
  TextPlaceholder = '#b9c0c4',
  /** 边框色 */
  Border = '#dbe1e5',
  /** 分割线色 */
  Divider = '#e7eef6',
  /** 蓝色（信息色）*/
  Blue = '#2876ff',
  /** 蓝色悬浮 */
  BlueHover = '#5eb1ff',
  /** 蓝色禁用 */
  BlueDisabled = '#EEF4FF',
  /** 绿色（成功色）*/
  Green = '#36c53f',
  /** 绿色禁用 */
  GreenDisabled = '#EFFBF0',
  /** 红色（错误色) */
  Red = '#f33d59',
  /** 红色禁用 */
  RedDisabled = '#FEF0F2',
  /** 橙色（警告色）*/
  Orange = '#FFA940',
  /** 橙色禁用 */
  OrangeDisabled = '#FFF6EB',
  /** 灰色 */
  Gray = '#72889e',
  /** 紫色 */
  Purple = '#a578ff',
  /** 自定义滚动条颜色（正常状态) */
  Scrollbar = '#cacfd3',
  /** 自定义滚动条颜色（hover状态）*/
  ScrollbarHover = '#afb6bc',
  /** 表格头部背景 */
  TableHeaderBg = '#F7F9FA',
  /** 表头/输入框禁用 */
  InputDisabled = '#f6f7f9',
  /** 填充 - hover */
  FillHover = '#f7f9fa',
  /** 填充 - 区域背景 */
  FillBg = '#F7F9Fa',
  /** 填充 - 禁用色/按钮 */
  FillDisabled = '#F6F7F9',
  /** 填充 - 全局背景 */
  FillGlobalBg = '#f0f2f5',
  /** 侧边栏背景颜色 */
  SiderBg = '#1d212c',
  /** Header 背景颜色 */
  HeaderBg = '#fff',
  /** 头像背景颜色 */
  AvatarBg = `linear-gradient(
 0deg,
 #fda602 0%,
 #fb7c34 100%
)`,
  /** 菜单抽屉、详情抽屉阴影 */
  DrawerShadow = '8px 8px 24px 0px rgba(0, 0, 0, 0.16)'
}
